import { getValue } from '../utils/ConfigProvider'

const CIS_COOKIE = 'cisId'
const FEATURE_TYPE_KEY = 'FT_'
const CHUNK_SIZE = getValue('features.availability.chunkSize')

const outOfStockLabel = {
  icon: 'out_of_stock',
  message: 'Out of stock'
}

const checkItemAvailability = messageKey => {
  const unavailableKeys = ['OUT_OF_STOCK', 'NOT_AVAILABLE']
  const isUnavailable = unavailableKeys.some(key => messageKey.includes(key))

  return isUnavailable
}

const replaceIcon = availability => {
  const { messageKey = '', icon = '' } = availability || {}
  const replaceIconKeys = [
    'COLLECTION_FROM_TODAY_AT_TIME',
    'COLLECTION_FROM_TOMORROW_AT_TIME',
    'COLLECTION_FROM_DATE',
    'FT_30_DELIVERY'
  ]

  const isMatched = replaceIconKeys.some(key => messageKey.includes(key))

  return isMatched ? 'tick' : icon
}

// Split array into size chunks
const chunkArray = (arr, size) =>
  arr.length > size ? [arr.slice(0, size), ...chunkArray(arr.slice(size), size)] : [arr]

// Displays the product labels for delivery & collection
const formatAvailabilityMessages = availability => {
  const { collection = {}, delivery = {} } = availability || {}

  const collectionKey = collection?.messageKey || ''
  const deliveryKey = delivery?.messageKey || ''

  const collectionLabels = collection
    ? {
        icon: replaceIcon(collection || {}),
        message: collection.text || ''
      }
    : {}

  const deliveryLabels = delivery
    ? {
        icon: replaceIcon(delivery || {}),
        message: delivery.text || ''
      }
    : {}

  const isCollectionUnavailable = checkItemAvailability(collectionKey)
  const isDeliveryUnavailable = checkItemAvailability(deliveryKey)

  if (isCollectionUnavailable && isDeliveryUnavailable) {
    return [outOfStockLabel]
  }

  const isFeatureType = collectionKey.indexOf(FEATURE_TYPE_KEY) === 0 && deliveryKey.indexOf(FEATURE_TYPE_KEY) === 0

  // Both fufilment methods are available
  if (!isCollectionUnavailable && !isDeliveryUnavailable) {
    if (isFeatureType) {
      // Collection and delivery messages are same for feature type products, so show one
      return [collectionLabels || deliveryLabels]
    }
    return [collectionLabels, deliveryLabels]
  }
  // Then either one or both are unavailable
  return isDeliveryUnavailable ? [collectionLabels] : [deliveryLabels]
}

// Returns valid partNumbers in a string format to use in availability endpoint
const formatProducts = (array = []) => {
  const isItemExcluded = (partNumber = '') => {
    const isClothing = partNumber
      .toString()
      .toLowerCase()
      .startsWith('tuc')

    return isClothing
  }

  const filteredProducts = array
    .filter(partNumber => partNumber && !isItemExcluded(partNumber))
    .map(partNumber => `${partNumber}_1`)

  return filteredProducts.toString()
}

// Formats and returns an object with delivery and collection information
const renderAvailabilityMessages = (partNumber = '', availabilityLabels = []) => {
  const availabilityLabel = availabilityLabels.find(label => label.partNumber === partNumber)
  if (availabilityLabel) {
    return formatAvailabilityMessages(availabilityLabel)
  }
  return {}
}

export { CIS_COOKIE, CHUNK_SIZE, chunkArray, formatAvailabilityMessages, formatProducts, renderAvailabilityMessages }
